import {
  APP_LOADING_DATA_DISABLE,
  APP_LOADING_DATA_ENABLE,
  APP_SUBMIT_PROTECTION_DISABLE,
  APP_SUBMIT_PROTECTION_ENABLE
} from './appMutationTypes'
import _ from 'lodash'
import { MutationTree } from 'vuex'
import AppState from '@/modules/app/store/AppState'

const mutations: MutationTree<AppState> = {
  async [APP_SUBMIT_PROTECTION_ENABLE] (state) {
    state.submitProtection = true
  },
  async [APP_SUBMIT_PROTECTION_DISABLE] (state) {
    state.submitProtection = false
  },
  async [APP_LOADING_DATA_ENABLE] (state, id: string) {
    state.loadingData.push(id)
  },
  async [APP_LOADING_DATA_DISABLE] (state, id: string) {
    state.loadingData = _.without(state.loadingData, id)
  }
}

export default mutations
